import { sortProduct } from "@/utils";
import { poll } from "../utils";
import { shuffleArray } from "@/utils/array";

function waitForTagReccomendations(): Promise<void> {
  return poll({
    checkFunction: () => {
      return Boolean(window.helium?.datastore?.current?.product?.details);
    },
    errorMessage: "Timeout waiting for tag recommendations",
  });
}
export const flattenObj = (
  ob: Record<string, any>,
  { seperator }: { seperator?: string } = { seperator: "-" },
) => {
  // The object which contains the
  // final result
  const result: Record<string, string> = {};

  // loop through the object "ob"
  for (const i in ob) {
    // We check the type of the i using
    // typeof() function and recursively
    // call the function again
    if (typeof ob[i] === "object" && !Array.isArray(ob[i])) {
      const temp = flattenObj(ob[i], { seperator });
      for (const j in temp) {
        // Store temp in result
        result[i + seperator + j] = temp[j];
      }
    }

    // Else store ob[i] in result directly
    else {
      result[i] = ob[i];
    }
  }
  return result;
};
const keyMap = {
  color: "tags.visual.color.primary.value",
  fit: "tags.visual.fit",
  design_style: "tags.visual.design_style",
};

export default async function handleTagBasedProducts(element: HTMLElement) {
  try {
    await waitForTagReccomendations();
    const currentProduct = window.helium?.datastore?.current?.product;
    if (!currentProduct?.details?.id) {
      console.warn("No product ID available");
      return;
    }
    const currentTags = window.helium?.datastore?.current?.product?.tags;

    const tagRecommendations =
      await window.helium.datastore.getTagRecommendation({
        id: currentProduct.details.id,
      });
    const flattenedObj = flattenObj(currentProduct?.tags, { seperator: "." });
    if (!tagRecommendations) {
      console.warn("No tag recommendations found");
      return;
    }
    let renderCount = 0;
    const productSet = new Set();
    tagRecommendations.labels.similar = "Similar Finds";
    const similar = await window.helium.datastore.getSimilar({
      id: currentProduct.details.id,
    });

    delete tagRecommendations.order;
    const entries = Object.entries(tagRecommendations);
    shuffleArray(entries);
    if (similar.length > 0) {
      entries.unshift(["similar", similar]);
    }
    for (const [attribute, productIds] of entries.slice(0, 4)) {
      if (!Array.isArray(productIds) || productIds.length === 0) continue;

      const sortedProductIds = await sortProduct({
        productsIds: productIds,
      });
      shuffleArray(sortedProductIds);
      const vproducts = await Promise.all(
        sortedProductIds.map(async (productId) => {
          try {
            //if (productSet.has(productId)) return null;
            const keepRepeat =
              window.heliumConfig &&
              window.heliumConfig?.features?.tag_recommendation
                ?.varietyStrategy === "repeat";

            if (!keepRepeat) {
              productSet.add(productId);
            }

            const product = await window.helium.datastore.getProduct({
              id: productId,
            });

            return product.details;
          } catch (error) {
            console.warn(`Failed to fetch product ${productId}:`, error);
            return null;
          }
        }),
      );

      const products = vproducts.filter(Boolean);

      const eleId = `helium-tag-based-products-${renderCount}`;
      let ele = document.getElementById(eleId);

      if (!ele && products.length > 0) {
        ele = document.createElement("div");
        ele.id = eleId;

        if (attribute === "similar") {
          await window.helium.ui.renderInlineBlock(
            ele,
            products,
            "Similar Finds",
            undefined,
            "inline-similar",
          );
        }
        const displayAttribute =
          attribute.charAt(0).toUpperCase() + attribute.slice(1).toLowerCase();
        //TODO: Find attribute
        let val = flattenedObj[keyMap[attribute]] ?? flattenedObj[attribute];
        let usedKey = attribute;
        if (!val) {
          Object.keys(flattenedObj).forEach((key) => {
            if (key.includes(attribute)) {
              usedKey = key;
              val = flattenedObj[key];
            }
          });
        }
        const isArray = Array.isArray(val);
        let txt = val;
        if (isArray) {
          txt = val.join(", ");
        }
        if (!txt) {
          //txt = attribute;
        }
        //console.log(attribute, val, txt, products, "xxxxxx");
        const labels = tagRecommendations?.labels ?? {};
        let label = labels[usedKey];

        if (!label) {
          label = txt
            ? `Curated in ${txt?.split?.("_")?.join?.(" ")} ${
                usedKey
                  ? usedKey
                      .split(".")
                      ?.at(-1)
                      ?.split?.("_")
                      ?.filter(Boolean)
                      ?.map((e) => e.slice(0, 1).toUpperCase() + e.slice(1))
                      ?.join?.(" ")
                  : ""
              }`
            : "Curated for you";
        }
        const eventData: Record<string, any> = {};
        attribute.split(",").forEach((attr) => {
          const val = flattenedObj[keyMap[attr]] ?? flattenedObj[attr];
          eventData[attr] = val;
        });

        await window.helium.ui.renderInlineBlock(
          ele,
          products,
          label,
          undefined,
          label === "Similar Finds" ? "inline-similar" : "tag_recommendations",
          eventData,
        );
        ele.classList.add("hp-mx-6", "md:hp-mx-20", "hp-pb-3", "hp-mt-12");
        element.appendChild(ele);
        renderCount++;
      }
    }
    if (renderCount === 0) {
      console.warn("No product blocks were rendered");
    }
  } catch (error) {
    console.error("Error in handleTagBasedProducts:", error);
  }
}
